module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notes-partial"
  }, [(_vm.notes.length) ? _c('div', {
    staticClass: "notes dropdown"
  }, [_c('p', {
    on: {
      "click": _vm.onNotesDropdownClick
    }
  }, [_vm._v("\n      Notes\n      "), _c('span', {
    staticClass: "glyphicon glyphicon-chevron-right"
  }), _vm._v(" "), _c('span', {
    staticClass: "border-bottom"
  })]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-drop"
  }, [_c('div', {
    staticClass: "dropdown-text-container"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "dropdown-text-wrapper"
  }, _vm._l((_vm.notes), function(note) {
    return _c('div', {
      staticClass: "dropdown-text",
      attrs: {
        "id": 'note' + note.id
      }
    }, [_c('div', {
      staticClass: "dropdown-desc"
    }, [_c('q', {
      domProps: {
        "innerHTML": _vm._s(note.title)
      }
    })])])
  })), _vm._v(" "), _c('span', {
    staticClass: "glyphicon glyphicon-chevron-right"
  })])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c9d0a82"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/epigram/Notes.vue
// module id = 100
// module chunks = 0